/**
 * Creates an array of header objects with default values.
 *
 * @param {Array<Object>} customHeaders - An array of custom header objects to be merged with default values.
 * @param {string} [customHeaders[].align] - The alignment of the header. Default is 'start'.
 * @param {boolean} [customHeaders[].sortable] - Indicates if the header is sortable. Default is false.
 * @param {string} [customHeaders[].width] - The width of the header. Default is '200'.
 * @returns {Array<Object>} An array of header objects with merged default and custom values.
 */
const createHeaders = (customHeaders) => {
  const defaultValues = {
    align: 'start',
    sortable: false,
    width: '200',
  };

  return customHeaders.map(header => ({
    ...defaultValues, 
    ...header, 
  }));
};

export default createHeaders;